import { Dispatch } from 'redux';

import { get, post, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import CustomAppTypes from '../config/customAppTypes';
import { AppState } from '../reducers';
import Pin from '../util/cryptopin';
import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

const pinPublicKey =
    process.env.NODE_ENV === 'production'
        ? 'E043025B0EE05CCB68E95D1EBAB3C2862B01393661B92B247390DA233466B0C7BEE263AEB41DB6C247702769472CF87CDCBEE1A5A664B80DFB70A60A0AAE1E0C5C5119220DB221F5139380297BE037E0E3BBB5D9B98154B680B2C9907512ACEC73B26AFBF3C4DE473F0C1C65BB2B1F83D340A2875BD97DCA999001BD71423D9439FE7E6F71C1AF4E18F7E48A7C07EBBB28FA7F4A8A2F4D9ACBB125E9BE731CB0AEF0EF3A4D37D74E477FB8EA7D8C86916DC7023879B7656345EAE068C6D287805C969EC28064B73C7D8D59E69B3ABAB2839735837A701215756585CA574693D03A7ED4840E90781C217D86137B533934453E5F508E056A2EDDF09FBF29E4B6A7'
        : '8C532782D40674F7734CC6355B2705C4CC36DEC03402C683B8216430926C27DA84E4943AB92404CA0B6BF480FCFE043168001523E4116BF818082CD140DA11D98F8F68486245B8F7BF4871789E172D361CD20FA300186506C79632D8C671BF834321226560734BDEC1A06FEA924F7E0BBDC00560A308EAF882C12051CB2E52A16A8D04065F098C45D09E5F23C7CC7F5CCECFAF6DFD05CA79017F6D76659370AE3284C820039D3EBDE8DF7752EECBD4231E146DC22E67FB8F13E3A774C22D262A30DD0D2CD521331F55565E820A85C3E8E87329281830F230F2688BB57598FD9069A65DF1365704170FC7F81A6ED8F0001B7F4CB54181BC50AF3017672A4376F1';

type Action<T> = import('./types').Action<T>;
// type SetPinSessionResponse = import('../generated-types').SetPinSesjon;
type SetPinResponse = number;

export interface SetPinStartedAction extends Action<typeof actionTypes.SET_PIN_STARTED> {
    type: typeof actionTypes.SET_PIN_STARTED;
}

export interface SetPinFulfilledAction extends Action<typeof actionTypes.SET_PIN_FULFILLED> {
    type: typeof actionTypes.SET_PIN_FULFILLED;
    payload: SetPinResponse;
}

export interface SetPinFailedAction extends Action<typeof actionTypes.SET_PIN_FAILED> {
    type: typeof actionTypes.SET_PIN_FAILED;
    payload: RequestExceptionWithResponse;
}

export type PinActions = SetPinStartedAction | SetPinFulfilledAction | SetPinFailedAction;

export const setPinStarted = (): SetPinStartedAction => ({
    type: actionTypes.SET_PIN_STARTED,
});
export const setPinFulfilled = (value: SetPinResponse): SetPinFulfilledAction => ({
    type: actionTypes.SET_PIN_FULFILLED,
    payload: value,
});
export const setPinFailed = (error: RequestExceptionWithResponse): SetPinFailedAction => ({
    type: actionTypes.SET_PIN_FAILED,
    payload: error,
});

export const setPin = async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
    const { application, context } = getState();
    const { pinkode } = application;

    try {
        dispatch(setPinStarted());

        const { audit, random, sgw }: any = await get(
            `${actionTypes.RESOURCE_PATH}/settpin/sesjon`,
            getRequestHeaders(context.config.bankregnr),
        );
        const p = new Pin(pinPublicKey);
        const data = p.generateEncryptedSetPinMessage(random, pinkode);
        const response: SetPinResponse = await post(
            `${actionTypes.RESOURCE_PATH}/settpin/pin`,
            {
                audit,
                data,
                sgw,
            },
            getRequestHeaders(context.config.bankregnr),
        );

        dispatch(setPinFulfilled(response));
    } catch (error) {
        dispatch(setPinFailed(error));
    }
};

export const setPinLbs = async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
    const { application, context, lbs } = getState();
    const { pinkode } = application;
    const lbsBnr = CustomAppTypes.isLbs(context) ? `/${lbs.lbsBankregnr}` : '';
    try {
        dispatch(setPinStarted());

        const { audit, random, sgw }: any = await get(
            `${actionTypes.RESOURCE_PATH}/settpin/sesjon${lbsBnr}`,
            getRequestHeaders(context.config.bankregnr),
        );
        const p = new Pin(pinPublicKey);
        const data = p.generateEncryptedSetPinMessage(random, pinkode);
        const response: SetPinResponse = await post(
            `${actionTypes.RESOURCE_PATH}/settpin/pin${lbsBnr}`,
            {
                audit,
                data,
                sgw,
            },
            getRequestHeaders(context.config.bankregnr),
        );

        dispatch(setPinFulfilled(response));
    } catch (error) {
        dispatch(setPinFailed(error));
    }
};
